<template>
    <div>
        <div class="alert alert-danger" v-if="error">{{ error }}</div>
        <div class="alert alert-success" v-if="success">{{ success }}</div>
        <template v-if="!success">
            <v-form-field
                class="mb-3"
                label="Your Name"
                name="name"
                v-model="name"
            />
            <v-form-field
                class="mb-3"
                label="Email"
                name="email"
                v-model="email"
            />
            <v-form-field
                class="mb-3"
                label="Phone (optional)"
                name="phone"
                v-model="phone"
            />
            <v-form-field
                class="mb-3"
                label="Company (optional)"
                name="organization"
                v-model="organization"
            />
            <v-form-field
                class="mb-3"
                label="Message"
                name="message"
                v-model="message"
            />
            <div class="text-right">
                <v-button @click="send">Send</v-button>
            </div>
        </template>
    </div>
</template>

<script>
import VFormField from "@/components/ui/VFormField";

let reset = () => {
    return {
        name: null,
        email: null,
        phone: null,
        organization: null,
        message: null,
        success: null,
        error: null
    };
};
export default {
    name: "ContactForm",
    components: {
        VFormField
    },
    props: {
        context: {
            type: String,
            default: ""
        }
    },
    data: reset,
    methods: {
        send() {
            this.error = null;
            if (!this.name || !this.email || !this.message) {
                this.error = "Please fill out the form";
                return;
            }
            this.$ladder
                .create("support-email", {
                    name: this.name,
                    email_phone: this.email + " " + this.phone,
                    organization: this.organization,
                    message: "*" + this.context + "* " + this.message
                })
                .then(() => {
                    Object.assign(this.$data, this.$options.data());
                    this.success =
                        "We'll be in touch as soon as possible. Thank you for reaching out.";
                })
                .catch(err => {
                    this.error = err.message;
                });
        }
    }
};
</script>
